/**
 * 国家/地区
 */
import {get} from '../utils/http';
import Region from '../models/Region';

// 获取所有国家/地区，并根据洲分类
// http://doc.oschina.net/xingchengzushou?t=244226
export function getAllAndClassify(order_id, regions) {
  let url = '/m/v2/?m=api/destination/index';

  return get(url,{
    data: {order_id, regions}
  })
    .then(function (data) {
      data.hot_region_list = data.hot_region_list.map(function (region) {
        return Region.parseInput(region);
      });

      // data.order_region_list = data.order_region_list.map(function (region) {
      //   return Region.parseInput(region);
      // });

      data.more_region_list = data.more_region_list.map(function (item) {
        item.list = item.list.map(function (region) {
          return Region.parseInput(region);
        });

        return item;
      });

      return data;
    });
}



// WEBPACK FOOTER //
// ./src/services/region.js